/* =====================================================================
   leadyourday – Warenkorb-Bridge für Horizon (MG Commerce) · v2
   - Plus-Buttons (Produktkarten, Quiz)                          [data-lyd-quick-add]
   - Kaufbox Produktseite (Menge, Staffel, „Dazu passt“)          form[data-lyd-pform]
   - Sticky-Kaufleiste                                           [data-lyd-sticky-atc]
   Nutzt dieselben Events wie Horizons product-form.js (@shopify/events).
   Dadurch aktualisieren sich Header-Zähler (cart.totalQuantity) und Cart-Drawer.
   Fallbacks: @theme/events (ältere Horizon-Versionen) → Weiterleitung /cart
   ===================================================================== */
const routes = () => (window.Theme && window.Theme.routes) || {};
const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const addUrl = () => (routes().cart_add_url || root() + 'cart/add').replace(/\.js$/, '');
const cartUrl = () => routes().cart_url || root() + 'cart';

let SE = null, TE = null, loaded = false;
async function loadEvents() {
  if (loaded) return; loaded = true;
  try { SE = await import('@shopify/events'); } catch (e) { SE = null; }
  if (!SE || !SE.CartLinesUpdateEvent) { try { TE = await import('@theme/events'); } catch (e) { TE = null; } }
}
const sectionIds = () => [...new Set([...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean))];
const openDrawer = () => { const d = document.getElementById('cart-drawer'); if (d && typeof d.open === 'function') { if (!d.isOpen) d.open(); return true; } return false; };

/**
 * Legt Artikel in den Warenkorb und benachrichtigt Horizon.
 * @param {{id:string|number, quantity:number}[]} items
 * @param {HTMLElement|null} btn  auslösender Button (Ladezustand)
 * @param {{errorEl?:HTMLElement, productId?:string, fallbackUrl?:string}} opts
 */
export async function lydAddItems(items, btn, opts = {}) {
  items = (items || []).filter((i) => i && i.id && Number(i.quantity) > 0);
  if (!items.length) return false;
  btn?.setAttribute('aria-busy', 'true');
  if (opts.errorEl) opts.errorEl.hidden = true;
  await loadEvents();
  const ids = sectionIds();
  const total = items.reduce((n, i) => n + Number(i.quantity), 0);

  let deferred = null;
  if (SE && SE.CartLinesUpdateEvent) {
    deferred = SE.CartLinesUpdateEvent.createPromise();
    (btn || document).dispatchEvent(new SE.CartLinesUpdateEvent({
      action: 'add', context: 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: Number(i.quantity) })),
      promise: deferred.promise
    }));
  }
  try {
    const body = { items: items.map((i) => ({ id: Number(i.id), quantity: Number(i.quantity) })) };
    if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
    const res = await fetch(addUrl() + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
    const json = await res.json();
    const failed = !res.ok || !!json.status;
    const ajaxCart = await fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

    if (deferred) {
      deferred.resolve({
        cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: { items: ajaxCart.items, source: 'lyd', sourceId: btn?.id || 'lyd', itemCount: total, productId: opts.productId, sections: json.sections, didError: failed }
      });
      if (failed && SE.CartErrorEvent) (btn || document).dispatchEvent(new SE.CartErrorEvent({ error: json.message || 'Add to cart failed', code: 'INVALID', detail: { description: json.description } }));
    } else if (TE && TE.CartAddEvent && !failed) {
      document.dispatchEvent(new TE.CartAddEvent({}, btn?.id || 'lyd', { source: 'lyd', itemCount: total, productId: opts.productId, sections: json.sections }));
    }

    if (failed) {
      if (opts.errorEl) { opts.errorEl.textContent = json.description || json.message || 'Konnte nicht hinzugefügt werden.'; opts.errorEl.hidden = false; }
      return false;
    }
    if (btn) { btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1600); }
    /* Sicherheitsnetz, falls Auto-Open im Theme deaktiviert ist */
    const onCartPage = !!document.querySelector('.cart-page');
    if (onCartPage) {
      /* Horizon rendert main-cart über detail.sections neu. Fallback, falls die Section nicht mitkam: */
      if (!json.sections || !Object.keys(json.sections).length) setTimeout(() => window.location.reload(), 150);
      /* Cross-Sell mit „Produkte im Warenkorb ausblenden“: hinzugefügte Sorte sofort aus dem Slider nehmen */
      const card = btn && btn.closest('[data-lyd-exclude-cart] [data-lyd-card]');
      if (card) setTimeout(() => { card.style.transition = 'opacity .3s'; card.style.opacity = '0'; setTimeout(() => card.remove(), 300); }, 700);
    } else {
      setTimeout(() => { if (!openDrawer()) window.location.href = cartUrl(); }, 120);
    }
    return true;
  } catch (e) {
    if (deferred) deferred.reject(e);
    window.location.href = opts.fallbackUrl || cartUrl();
    return false;
  } finally {
    btn?.removeAttribute('aria-busy');
  }
}
window.lydAddItems = lydAddItems;

/* ---------- Plus-Buttons (Karten, Quiz) ---------- */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-lyd-quick-add]');
  if (!btn) return;
  e.preventDefault();
  lydAddItems([{ id: btn.dataset.variantId, quantity: parseInt(btn.dataset.qty || '1', 10) || 1 }], btn, {
    errorEl: btn.closest('[data-lyd-card]')?.querySelector('[data-lyd-card-err]'),
    productId: btn.dataset.productId, fallbackUrl: btn.dataset.productUrl
  });
});

/* ---------- Kaufbox Produktseite ---------- */
document.addEventListener('submit', (e) => {
  const form = e.target.closest('form[data-lyd-pform]');
  if (!form) return;
  e.preventDefault();
  const box = form.closest('lyd-buybox');
  const qtyEl = form.querySelector('[name="quantity"]');
  const items = box && typeof box.getItems === 'function'
    ? box.getItems()
    : [{ id: form.querySelector('[name="id"]').value, quantity: parseInt(qtyEl ? qtyEl.value : '1', 10) || 1 }];
  lydAddItems(items, form.querySelector('[data-lyd-main-atc]'), { errorEl: form.querySelector('[data-lyd-form-err]'), productId: form.dataset.productId, fallbackUrl: form.action });
});

/* ---------- Sticky-Kaufleiste ---------- */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-lyd-sticky-atc]');
  if (!btn) return;
  e.preventDefault();
  const form = document.querySelector('form[data-lyd-pform]');
  if (form) { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); return; }
  lydAddItems([{ id: btn.dataset.variantId, quantity: 1 }], btn, { productId: btn.dataset.productId });
});

/* Cart-Drawer liegt auf Desktop ÜBER der Seite (lyd-cart-drawer.css). Klick aufs Overlay schließt ihn,
   wie auf Mobil (dort erledigt das Horizons Modal-Backdrop). */
let lydDownOnOverlay = false;
document.addEventListener('pointerdown', (e) => {
  lydDownOnOverlay = e.target === document.body && !!document.querySelector('theme-drawer#cart-drawer[open]');
}, true);
document.addEventListener('click', (e) => {
  const drawer = document.querySelector('theme-drawer#cart-drawer[open]');
  const ok = lydDownOnOverlay && e.target === document.body;
  lydDownOnOverlay = false;
  if (!drawer || !ok) return;
  if (typeof drawer.close === 'function') drawer.close();
});

/* Leerer Drawer: „Weiter einkaufen“ schließt den Einschub, statt die Seite neu zu laden (Link bleibt als Fallback) */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('#cart-drawer .cart-items__empty-button');
  if (!btn) return;
  const drawer = document.querySelector('theme-drawer#cart-drawer');
  if (!drawer || typeof drawer.close !== 'function') return;
  e.preventDefault();
  drawer.close();
  try { sessionStorage.removeItem('theme-drawer-open'); } catch (err) { /* ignore */ }
});
